var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpDownArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1833 7.81669L13.6733 14.3267C12.9267 15.05 13.44 16.31 14.49 16.31H18.6667V30.3334C18.6667 31.6167 19.7167 32.6667 21 32.6667C22.2833 32.6667 23.3333 31.6167 23.3333 30.3334V16.31H27.51C28.56 16.31 29.0733 15.05 28.3267 14.3267L21.8167 7.81669C21.3733 7.37336 20.6267 7.37336 20.1833 7.81669ZM37.3333 39.69V25.6667C37.3333 24.3834 36.2833 23.3334 35 23.3334C33.7167 23.3334 32.6667 24.3834 32.6667 25.6667V39.69H28.49C27.44 39.69 26.9267 40.95 27.6733 41.6734L34.1833 48.16C34.65 48.6034 35.3733 48.6034 35.84 48.16L42.35 41.6734C43.0967 40.95 42.56 39.69 41.5333 39.69H37.3333Z",
    fill: "#FFDE33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDownArrow);
export default __webpack_public_path__ + "static/media/UpDownArrow.4967942bf206c83773e787960b67294d.svg";
export { ForwardRef as ReactComponent };